<template>
  <StaticDataTable class="static-table-list">
    <template v-slot:header>
      <tr>
        <th>Type</th>
        <th>Item (HxW)</th>
        <th>Alloc (HxW)</th>
        <th>Trim</th>
        <th>Layout</th>
        <th>Settings</th>
        <th>Cutting Info</th>
        <th>Barcode</th>
        <th>Order</th>
      </tr>
    </template>
    <template v-slot:body v-if="allocationList">
      <tr v-for="allocation of allocationList" :key="allocation.id">
        <td class="font-weight-bold">
          {{formatLookupName(allocation.type, SheetAllocationTypeLookup)}}
        </td>
        <td>{{generateAllocContentSizeLabel(allocation)}}</td>
        <td>{{generateAllocRegionSizeLabel(allocation)}}</td>
        <td>T:{{allocation.trimTop}}mm, R:{{allocation.trimRight}}mm, B:{{allocation.trimBottom}}mm, L:{{allocation.trimLeft}}mm</td>
        <td>{{generateAllocLayoutLabel(allocation)}}</td>
        <td>{{generateAllocSettingsLabel(allocation)}}</td>
        <td>{{generateAllocCuttingLabel(allocation)}}</td>
        <td>
          <LinkProductionPanel
            v-if="allocation.type == SheetAllocationTypes.panel && allocation.productionPanel"
            :id="allocation.productionPanel.id"
            :name="allocation.productionPanel.barcode"
            :disabled="!linksEnabled"
          />
          <span v-if="allocation.type == SheetAllocationTypes.offcut && allocation.glassLevel">{{allocation.glassLevel.barcode}}</span>
        </td>
        <td>
          <LinkOrder
            v-if="(allocation.type == SheetAllocationTypes.panel || allocation.type == SheetAllocationTypes.splitPanel) && allocation.order"
            :id="allocation.order.id"
            :name="allocation.order.sequenceNumber"
            :disabled="!linksEnabled"
          />
          <span v-else>-</span>
        </td>
      </tr>
    </template>
    <template v-slot:empty v-if="!allocationList || allocationList.length == 0">No allocations</template>
  </StaticDataTable>
</template>


<script>
import LabelSheetStatusBadge from '@/modules/optimiser/components/labelSheetStatusBadge'
import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'

import { LinkTypes, OptimiserSheetStatusTypes, SheetAllocationTypes, SheetAllocationTypeLookup } from '@/store/types'

export default {
  name: 'OptimiserAllocLayoutList',
  components: {
    LabelSheetStatusBadge,
    LabelOrderStatusBadge
  },
  props: {
    allocationList: Array,
    linksEnabled: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.LinkTypes = LinkTypes
    this.SheetAllocationTypes = SheetAllocationTypes
    this.SheetAllocationTypeLookup = SheetAllocationTypeLookup
  },
  methods: {
    generateAllocContentSizeLabel(allocation) {
      let width = allocation.width
      let height = allocation.height

      if(allocation.type == SheetAllocationTypes.panel) {
        width = allocation.productionPanel.panelWidth
        height = allocation.productionPanel.panelHeight
      }
      if(allocation.type == SheetAllocationTypes.offcut) {
        width += allocation.overflowLeft + allocation.overflowRight
        height += allocation.overflowTop + allocation.overflowBottom
      }

      return `${height} x ${width}`
    },
    generateAllocRegionSizeLabel(allocation) {
      let width = allocation.width
      let height = allocation.height

      return `${height} x ${width}`
    },
    generateAllocLayoutLabel(allocation) {
      var layoutInfo = []
      if(allocation.isRotated)
        layoutInfo.push('Rotated')
      if(allocation.flippedHorz != allocation.flippedVert)
        layoutInfo.push('Flipped')

      if(layoutInfo.length == 0)
        layoutInfo.push('-')

      return layoutInfo.join(', ')
    },
    generateAllocSettingsLabel(allocation) {
      var settingsInfo = []
      if(allocation.isPanelSizeOverridden)
        settingsInfo.push('Size Override')
      if(allocation.isPanelShapeCuttingDisabled)
        settingsInfo.push('Shape Cutting Disabled')
      if(allocation.isPanelTrimOverridden)
        settingsInfo.push('Trim Override')

      if(settingsInfo.length == 0)
        settingsInfo.push('-')

      return settingsInfo.join(', ')
    },
    generateAllocCuttingLabel(allocation) {
      var settingsInfo = []
      if(allocation.reliefCutList && allocation.reliefCutList.length > 0)
        settingsInfo.push(`${allocation.reliefCutList.length} relief cut(s)`)
      if(allocation.cutoutList && allocation.cutoutList.length > 0)
        settingsInfo.push(`${allocation.cutoutList.length} cutout(s)`)

      if(settingsInfo.length == 0)
        settingsInfo.push('-')

      return settingsInfo.join(', ')
    },
    generateAllocBarcodeLabel(allocation) {
      if(allocation.type == SheetAllocationTypes.panel && allocation.productionPanel)
        return allocation.productionPanel.barcode
      if(allocation.type == SheetAllocationTypes.offcut && allocation.glassLevel)
        return allocation.glassLevel.barcode
      return '-'
    },
    generateAllocOrderLabel(allocation) {
      if(allocation.type == SheetAllocationTypes.panel)
        return allocation.order.sequenceNumber
      return '-'
    },
  }

}
</script>